export default __webpack_public_path__ + "static/media/_DSC0009.9da71025.jpg";